<template lang="pug">
  div
    el-row#header-row()
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;")
        // Logo
        div(style="min-height: 70px; min-width: 120px; margin: 10px;")
          img(
              v-if="isGraded"
              src="~@/assets/hvu_quiz_icon.svg"
            )
          img(
            v-else
            src="~@/assets/hvu_practice_icon.svg"
          )
        // Title
        div(v-if="form.title" style="width: 90%;")
          h2#title-info {{ form.title }}
        div(v-else)
          span(v-html="form.description")
      
      // Divider
      div(v-if="form.description && form.title" style="margin: 2%;")
        hr(style="border: 0.5px solid #e6e6e6;")

      // Content
      div#info-content(v-if="form.title !== ''")
        span(v-html="form.description")
</template>

<script>
import utilMixin from '@/components/mixins/utilMixin'

export default {
  name: 'QuizInfoView',

  mixins: [utilMixin],

  data() {
    return {
      userData: { 
        userId: this.$store.state.canvasData.userId,
      },
      form: {
        title: '',
        description: '',
      },
      isGraded: false,
    }
  },

 created() {
    this.fetchQuiz()
  }, 

  methods: {
    fetchQuiz() {
      // Workaround for determining module id from parent window url
      const parentUrl = (window.location != window.parent.location)
              ? document.referrer
              : document.location.href
      const urlParams = this.mGetUrlVar(parentUrl)
      const itemId = urlParams['items'] || urlParams['assignments']

      this.axios.get('/api/user/' + this.userData.userId + '/quiz/' + itemId)
        .then((result) => {
          this.axios.defaults.headers.common['X-CSRF-TOKEN'] = result.data.csrfToken
          this.form = {title: result.data.object.title, description: result.data.object.description}
          this.origForm = {title: result.data.object.title, description: result.data.object.description}
          this.isGraded = result.data.isGraded
          const quizData = { 
            id:result.data.object.id, 
            resourceId:result.data.object.c_resource_id,
            itemId:result.data.object.c_item_id,
            isGraded:result.data.isGraded,
            isEnrolled:result.data.isEnrolled,
          }
          this.$store.commit('setQuiz', quizData)
        })
        .catch((error) => {
          this.mNotification({error: error, message: 'Error fetching quiz data.'})
        })
    },
  },
}
</script>

<style module>

  #header-row {
    border: 1px solid #f1f1f1;
    border-radius: 7px;
    margin: 0% 2% 1.5% 2%;
  }

  #title-info {
    font-size: 2em;
    margin-top: 1%;
    margin-bottom: 1%;
  }

  #info-content {
    color: #606266;
    font-size: 1em;
    margin: 2% 4% 2% 4%;
  }

  #icon-img {
    margin: 10% 10% 10% 10%;
    text-align: center;
  }

</style>